




































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import TextField from "@/components/inputs/TextField.vue";
import SeoEntity from "@/entity/SeoEntity";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

@Component({
    components:{
        ImageUpload,
        EForm,TextField
    }
})
export default class SeoForm extends Vue {
    @Prop({default:()=>new SeoEntity()}) data!:SeoEntity;
    dialog:boolean = false;
    imageRemoved:boolean = false;
    success(){
        this.imageRemoved = false;
        this.$emit('success');
    }
    action(){
        if(this.data.seo_id)
            return "seo/"+this.data.seo_id;
        return "seo";
    }
    /** Başka bir kayıt açıldığında "kaldırılacak" uyarısı taşınmasın */
    @Watch("data")
    onDataChanged(){
        this.imageRemoved = false;
    }
    /** Görsel alanını boşaltır; sunucu POST'ta dosyayı silmeden kaydı günceller */
    removeImage(){
        this.$set(this.data as any, "og_image_url", "");
        // Önceden seçilmiş yeni dosya da atılır: yoksa "kaldırıldı" denmesine
        // rağmen Gönder'de o dosya yüklenip görsel olarak kaydediliyordu.
        // undefined bırakılmaz, anahtar silinir: FormData onu "undefined" metni olarak gönderirdi.
        this.$delete(this.data as any, "file");
        this.imageRemoved = true;
    }
    /** Kaldırdıktan sonra yeni dosya seçildiyse o yüklenecek; uyarı kalkar */
    @Watch("data.file")
    onFileChanged(file:any){
        if(file){
            this.imageRemoved = false;
        }
    }
}
